<template>
  <el-collapse v-model="activeNames">
    <el-collapse-item title="设置展开项" name="1">
      <span>选择需要展开的分类</span>
      <div class="option-choose-container">
        <el-radio-group v-model="currentSetMenu"  @input="selectSubmenu">
          <el-radio
            :label="option.publicId"
            v-for="option in selectOptions"
            :key="option.publicId"
            style="width: 100%"
            >{{ option.label }}</el-radio
          >
        </el-radio-group>
      </div>
    </el-collapse-item>
    <el-collapse-item title="选择样式" name="2" class="padding_0">
      <subStyles 
        :productStyles="subMenuTypes" 
        :selectId.sync="currentMenuStyleType" @select="selectSubMenuType"></subStyles>
    </el-collapse-item>
  </el-collapse>
</template>
<script>
import { simpleDeepClone } from "utils"
import subStyles from './subStyles.vue';
export default {
  components: {
    subStyles
  },
  props: {
    options: Object,
    currentSetStyle: undefined,
    rectId: undefined,
    // selectOptions: Array,
    subMenuConfig: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeNames: ["1","2","3"],
      subMenuTypes: [
        {
          id: 1,
          name: "样式一",
          cover: require('./images/style1.png')
        }
      ],
      // currentSetMenu: undefined,
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    selectOptions() {
      return this.options.selectOptions
    },
    currentSetOption: {
      get() {
        const activeOption = this.selectOptions?.find(item => item.active)
        return activeOption ? activeOption?.publicId : this.selectOptions[0]?.publicId
      },
      set(newVal) {
        this.selectOption(newVal)
      }
    },
    subMenuIndex() {
      return this.subMenuConfig.findIndex(item => item.menuId === this.currentSetMenu)
    },
    currentMenuStyleType: {
      get() {
        return this.subMenuConfig.find(item => item.menuId === this.currentSetMenu)?.styleId || 1
      },
      set(styleId) {
        this.$emit('update:currentSetStyle', styleId)
      }
    },
    currentSetMenu: {
      get() {
        return this.options.activeValue || this.selectOptions[0]?.publicId
      },
      set(val) {
        this.$store.dispatch(this.request_prefix + "/changeOptions", {
          ...this.ids,
          option_name: "activeValue",
          option_val: val
        })
      }
    },
  },
  mounted() {
    this.selectSubmenu(this.currentSetMenu)
  },
  methods: {
    selectSubmenu(menuId) {
      const menuConfig = this.subMenuConfig.find(item => item.menuId === menuId)
      if (menuConfig) {
        this.currentMenuStyleType = menuConfig.styleId
      } else {
        this.$emit('update:subMenuConfig', this.subMenuConfig.slice(0).concat([{menuId, styleId: 1}]))
        this.currentMenuStyleType = 1
      }
      this.$eventBus.$emit('openSelectedSubMenu', {
        rect_id: this.rectId,
        publicId: menuId
      })
    },
    selectSubMenuType(styleId) {
      const index = this.subMenuConfig.findIndex(item => item.menuId === this.currentSetMenu)
      // this.$emit('update:menuConfig', this.subMenuConfig.slice(0).concat([{menuId, styleId: 1}]))
      const newSubMenuConfig = produce(this.subMenuConfig, draft => {
        if (index === -1) {
          draft.push({styleId, extraConfig: {}, menuId: this.currentSetMenu})
        } else {
          draft.splice(index, 1, {...this.subMenuConfig[index], styleId, extraConfig: {}, menuId: this.currentSetMenu})
        }
      })
      this.$emit('update:subMenuConfig', newSubMenuConfig)
      this.currentMenuStyleType = styleId
      this.$eventBus.$emit('openSelectedSubMenu', {
        rect_id: this.rectId,
        publicId: this.currentSetMenu
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.menu-choose-container {
  border-radius: 4px;
  padding: 5px 12px;
  background-color: var(--cardBgColor);
  border: 1px solid var(--sliderBackGround);
}
</style>
